module.exports = __webpack_public_path__ + "static/media/Sign Up 2.498573a5.svg";